import { render } from "./IdleTimePopup.vue?vue&type=template&id=f65eac1e&scoped=true&ts=true"
import script from "./IdleTimePopup.vue?vue&type=script&lang=ts"
export * from "./IdleTimePopup.vue?vue&type=script&lang=ts"

import "./IdleTimePopup.vue?vue&type=style&index=0&id=f65eac1e&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ms-frontend-vue_us_qa_v1.39.20_2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65eac1e"]])

export default __exports__